import Call from '../Call';
import {objToQs} from '../Utils';

const Bidder = {
    get(filters) {
        return Call(`bidder?${objToQs(filters)}`);
    },

    get2(filters, type) {
        return Call(`bidder2/${type}?${objToQs(filters)}`);
    },

    getV2(filters) {
        return Call(`bidder/v2?${objToQs(filters)}`);
    },

    getV2Graph(filters) {
        return Call(`bidder/v2/graph?${objToQs(filters)}`);
    },

    get3(filters, type) {
        return Call(`bidder3/${type}?${objToQs(filters)}`);
    },

    getHourly(filters, type) {
        return Call(`bidderHourly/${type}?${objToQs(filters)}`);
    },

    getHourlyV2(filters) {
        return Call(`bidderHourly/v2?${objToQs(filters)}`);
    },

    getHourlyV2Graph(filters) {
        return Call(`bidderHourly/v2/graph?${objToQs(filters)}`);
    }
};

export default Bidder;


// WEBPACK FOOTER //
// ./src/services/API/components/Bidder.js